var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switcher"},[_c('div',{staticClass:"lang-wrapper",on:{"click":this.toggleShow}},[_c('router-link',{staticClass:"text-center",attrs:{"to":_vm.nextRoute}},[_vm._v("\n      "+_vm._s(_vm.displayLanguage.name)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }